import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const document = inject(DOCUMENT);
  const auth = inject(AuthService);
  const url = new URL(request.url, document.location.origin);
  const sameOrigin = url.origin === document.location.origin;
  const api = sameOrigin && (url.pathname === '/msi/api' || url.pathname.startsWith('/msi/api/'));
  const logout = sameOrigin && url.pathname === '/auth/logout';
  const csrf = auth.session()?.csrfToken;
  const unsafe = !['GET', 'HEAD', 'OPTIONS'].includes(request.method);
  const outgoing = (api || logout) && unsafe && csrf
    ? request.clone({ setHeaders: { 'X-CSRF-Token': csrf } }) : request;
  return next(outgoing).pipe(catchError((error: unknown) => {
    if (api && error instanceof HttpErrorResponse && error.status === 401) auth.sessionExpired();
    return throwError(() => error);
  }));
};